function updateEstimatedLeaseDetails(leaseCalculationData) {
	if (isNullUndefined(leaseCalculationData)) {
		var pageType = $('.pageTypeValue').val();
		if (!isNullUndefined(pageType)) {
			if (pageType == 'PRODUCT') {
				var pdpEstimatedLeaseDetailsDiv = $('#pdpEstimatedLeaseDetails');
				var pdpEstimatedLeaseErrorDiv = $('#pdpEstimatedLeaseError');
				pdpEstimatedLeaseDetailsDiv.addClass("d-none");
				pdpEstimatedLeaseErrorDiv.removeClass("d-none");
			} else if (pageType == 'CART') {
				var leaseDetailsMainDiv = $('#leaseDetailsMainDiv');
				var leaseCalculationErrorMainDiv = $('#leaseCalculationErrorMainDiv');
				leaseCalculationErrorMainDiv.removeClass("d-none");
				leaseDetailsMainDiv.addClass("d-none");

			}
		}
	} else {
		var paymentFrequencyDiv = $('.payment-frequency');
		var numberOfPaymentsDiv = $('.number-of-payments');
		var leaseRenewalRateDiv = $('.lease-renewal-rate');
		var totalLeasePaymentDiv = $('.total-lease-payment');
		var earlyPurchaseDiv = $('.early-purchase');
		paymentFrequencyDiv.text(leaseCalculationData.paymentFrequency);
		numberOfPaymentsDiv.text(leaseCalculationData.noOfRenewalPayments);
		leaseRenewalRateDiv.text(leaseCalculationData.renewalPaymentAmount.formattedValue);
		totalLeasePaymentDiv.text(leaseCalculationData.totalOfPayments.formattedValue);
		earlyPurchaseDiv.text(leaseCalculationData.ninetyDayPurchase.formattedValue);

		var pageType = $('.pageTypeValue').val();
		if (!isNullUndefined(pageType)) {
			if (pageType == 'PRODUCT') {
				var pdpEstimatedLeaseDetails = $('#pdpEstimatedLeaseDetails');
				var pdpEstimatedLeaseError = $('#pdpEstimatedLeaseError');
				pdpEstimatedLeaseError.addClass("d-none");
				pdpEstimatedLeaseDetails.removeClass("d-none")
			} else if (pageType == 'CART') {
				var leaseDetailsMainDiv = $('#leaseDetailsMainDiv');
				var leaseCalculationErrorMainDiv = $('#leaseCalculationErrorMainDiv');
				leaseCalculationErrorMainDiv.addClass("d-none");
				leaseDetailsMainDiv.removeClass("d-none");
			}
		}
	}
}

function calculateLeaseByPaymentFrequency(paymentFrequency) {
	var pageType = $('.pageTypeValue').val();
	var isAllNonLeasable = $('#isAllNonLeasable').attr('data-value');
	var leaseCalculationUrl = '';
	if (!isNullUndefined(pageType)) {
		if (pageType == 'PRODUCT') {
			var productPrice = $('#acimaProductPrice').attr('data-value');
			if (!isNullUndefined(productPrice)) {
				let acimaSelectedPaymentFrequency = getAndUpdatePaymentFrequencyFormValue(paymentFrequency);
				if (!isNullUndefined(acimaSelectedPaymentFrequency)) {
					leaseCalculationUrl = ACC.config.encodedContextPath + '/calculateLease?paymentFrequency=' + acimaSelectedPaymentFrequency + '&price=' + `${productPrice}`;
					callLeaseCalculcationApi(leaseCalculationUrl);
				}
			}
		} else if (pageType == 'CART') {
			if (isNullUndefined(isAllNonLeasable) || isFalse(isAllNonLeasable)) {
				let acimaSelectedPaymentFrequency = getAndUpdatePaymentFrequencyFormValue(paymentFrequency);
				if (!isNullUndefined(acimaSelectedPaymentFrequency)) {
					leaseCalculationUrl = ACC.config.encodedContextPath + '/calculateLease?paymentFrequency=' + acimaSelectedPaymentFrequency;
					callLeaseCalculcationApi(leaseCalculationUrl);
				}
			}
		}
	}
}

function callLeaseCalculcationApi(leaseCalculationUrl) {
	$.ajax({
		url: `${leaseCalculationUrl}`,
		method: 'GET',
		beforeSend: function() {
			$(".estimation-lease-invoice-loading-spinner").removeClass('hide');
			$("#pdpEstimatedLeaseDetails").addClass("hide");
			$("#leaseDetailsMainDiv").addClass("hide");

		},
		success: function(leaseCalculationData) {
			updateEstimatedLeaseDetails(leaseCalculationData);
		},
		error: function() {
			ACIMA.loadingSpinnerHide();
		},
		complete: function() {
			$("#pdpEstimatedLeaseDetails").removeClass("hide");
			$("#leaseDetailsMainDiv").removeClass("hide");
			$(".estimation-lease-invoice-loading-spinner").addClass('hide');
		}
	});
}


$(document).ready(function() {
	updatePaymentFrequencyLabel();
	var pageType = $('.pageTypeValue').val();
	if (!isNullUndefined(pageType)) {
		if (pageType == 'PRODUCT') {
			let selectedPaymentFrequecy = $("input[type='radio'][name=paymentFrequency]:checked").val();
			calculateLeaseByPaymentFrequency(selectedPaymentFrequecy);
		}
	}
});

$('.value-container').click(function() {
	$('.leasePayment-options-container').toggle();
});

$('input[type="radio"][name=paymentFrequency]').click(function() {
	var selectedOption = $("input[type='radio'][name=paymentFrequency]:checked").val();
	if (!isNullUndefined(selectedOption)) {
		updatePaymentFrequencyLabel();
		calculateLeaseByPaymentFrequency(selectedOption);
	}
	$('.leasePayment-options-container').hide();
});

$(document).click(function(event) {
	if (!$(event.target).closest('.leasePayment-container').length) {
		$('.leasePayment-options-container').hide();
	}
});

function updatePaymentFrequencyLabel() {
	let paymentFrequencyValueSpanId = "paymentFrequencyValueSpan-" + $("input[type='radio'][name=paymentFrequency]:checked").data("index");
	$(".paymentFrequencyValueSpan").text($("." + paymentFrequencyValueSpanId).eq(0).text());
}

function getAndUpdatePaymentFrequencyFormValue(paymentFrequency) {
	var approvedPaymentFrequency = $('#approvedPaymentFrequency').attr('data-value');
	if (isNullUndefined(approvedPaymentFrequency)) {
		$("#acimaSelectedPaymentFrequency").val(paymentFrequency);
		return paymentFrequency;
	} else {
		$("#acimaSelectedPaymentFrequency").val(approvedPaymentFrequency);
		return approvedPaymentFrequency;
	}
}

function leaseErrorModal() {
	let pdp_selected_val = $("input[type='radio'][name=paymentFrequency]:checked").val();
	calculateLeaseByPaymentFrequency(pdp_selected_val);
}